import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { config } from 'src/app/config/api.config';
import { Admis } from 'src/app/model/Admis';
import { Apprenant } from 'src/app/model/Apprenant';
import { ApprenantFode } from 'src/app/model/apprenantFode.model';
import { Statistics } from 'src/app/model/statistics.model';
import { Beneficiary } from 'src/app/model/beneficiary.model';
import { TestQualification } from 'src/app/model/TestQualification';
import { TestQualificationToSend } from 'src/app/model/TestQualificationToSend';
import { NewParcourCertificate } from 'src/app/model/NewParcourCertificate';
import { CusstomResponseDTO } from 'src/app/model/dto/custom-response';
import { th } from 'date-fns/locale';
import { CustomResponse } from 'src/app/model/dto/CustomResponse';
import { OFFTRACK } from '../components/hors-sigui/off-track.model';

@Injectable({
  providedIn: 'root',
})
export class PlateformeLMSService {
  constructor(private httpClient: HttpClient) {}

  getListCertificat(iuf: String): Observable<CustomResponse[]> {
    return this.httpClient.get<CustomResponse[]>(
      `${config.apiBaseUrl}/certificats/choices/` + iuf,
    );
  }

  getListOfNewParcourcertificate(): Observable<NewParcourCertificate[]> {
    return this.httpClient.get<NewParcourCertificate[]>(
      `${config.apiBaseUrl}/newParcourCertificate/All`,
    );
  }
  getListOfNewParcourcertificateByCohorte(
    cohorte: string,
  ): Observable<NewParcourCertificate[]> {
    return this.httpClient.get<NewParcourCertificate[]>(
      `${config.apiBaseUrl}/newParcourCertificate/cohorte/` + cohorte,
    );
  }

  getOneNewParcourcertificate(id: number): Observable<CusstomResponseDTO> {
    return this.httpClient.get<CusstomResponseDTO>(
      `${config.apiBaseUrl}/newParcourCertificate/` + id,
    );
  }

  chooseCertificate(
    iuf: string,
    idcertificat: number,
  ): Observable<CusstomResponseDTO> {
    return this.httpClient.post<CusstomResponseDTO>(
      `${config.apiBaseUrl}/certificats/choosecertificate/` +
        iuf +
        `/` +
        idcertificat,
      null,
    );
  }

  chooseCertificateImproved(
    iuf: string,
    idcertificat: number,
    cohorte: string,
  ): Observable<CusstomResponseDTO> {
    return this.httpClient.post<CusstomResponseDTO>(
      `${config.apiBaseUrl}/fCohorteParcours/choosecertificate/` +
        iuf +
        `/` +
        idcertificat +
        `/` +
        cohorte,
      null,
    );
  }

  getListOfElligible(iuf: string) {
    return this.httpClient.get<CustomResponse>(
      `${config.apiBaseUrl}/newtestqualification/getlistTest/${iuf}`,
    );
  }

  checkStep(iuf: string) {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/certificats/checkStep/${iuf}`,
    );
  }

  checkStepImproved(iuf: string, cohorte: string) {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/certificats/checkStepImproved/${iuf}/${cohorte}`,
    );
  }

  listCategory(): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/certificatCategory/all`,
    );
  }

  getCategory(id: any): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/certificatCategory/find/${id}`,
    );
  }

  listCertificatCategory(id: any): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/certificatCategory/certificatBycategory/${id}`,
    );
  }

  uploadCSV(csvFile: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', csvFile);
    return this.httpClient.post(
      `${config.apiBaseUrl}/apprenant-coursera/upload`,
      formData,
    );
  }

  getCourseraByIUF(IUF: string): Observable<any> {
    return this.httpClient.get<any>(`${config.apiBaseUrl}/coursera/` + IUF);
  }

  checkFirstAccess(IUF: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/coursera/first-access/` + IUF,
    );
  }

  chekcFirstAccesPPP(iuf: string, cohorte: string): Observable<any> {
    const params = new HttpParams().set('iuf', iuf).set('cohorte', cohorte);

    return this.httpClient.post<any>(
      `${config.openBaseUrl}/opencontroller/sendNotificationToPPP`,
      null,
      { params },
    );
  }

  firstAccess(iuf: string, cohorte: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/vcn/${iuf}/${cohorte}`,
    );
  }

  getAllOffTrackByIUF(iuf: string): Observable<OFFTRACK[]> {
    return this.httpClient.get<OFFTRACK[]>(
      `${config.apiBaseUrl}/off-tracks/` + iuf,
    );
  }

  getFamilybyiufImprovImprov(iuf: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/newtestqualification/getFamilyName/${iuf}`,
    );
  }

  getFamilybyiufByNewParcoursImprov(iuf: string): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/newtestqualification/getFamilyNameInNewParcoursTest/${iuf}`,
    );
  }

  getTestqualifbycohandfamilyImprov(
    cohorte: string,
    family: string,
  ): Observable<any> {
    return this.httpClient.get<any>(
      `${config.apiBaseUrl}/newtestqualification/${cohorte}/${family}`,
    );
  }
  getListOfElligiblebyFamilyIufImprov(
    familyName: string,
    iuf: string,
    cohorte: string,
  ) {
    return this.httpClient.get<CustomResponse>(
      `${config.apiBaseUrl}/newtestqualification/getlistTest/${familyName}/${iuf}/${cohorte}`,
    );
  }
  getListCertificatCohorteByfamilyImprov(
    iuf: String,
    cohorte: string,
  ): Observable<CustomResponse[]> {
    return this.httpClient.get<CustomResponse[]>(
      `${config.apiBaseUrl}/certificats/choices/` + iuf + '/' + cohorte,
    );
  }
}
